import {getDateUtilDefaultInstance} from '/util/date.util';
import {sumKey} from '/util/number.util';

export const getExpiringBeforeNextPremier = ({scheduledOn, history}: any) => {
  const expiringBeforeNextPremierHistory = history?.filter(
    (wellnessCredits: any) =>
      getDateUtilDefaultInstance().getTimePassed(
        wellnessCredits.expiresOn,
        scheduledOn,
      ) > 0,
  );
  return sumKey(expiringBeforeNextPremierHistory, 'value');
};
